import React from 'react';
import { Card } from 'antd';
import { SkBar } from './_primitives';

const EmployeesHeader = () => (
  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 mb-4 sm:mb-6">
    <div className="flex flex-col gap-2 min-w-0 flex-1">
      <div className="flex items-center gap-2">
        <SkBar h="h-3" w="w-16" />
        <SkBar h="h-3" w="w-2" />
        <SkBar h="h-3" w="w-40" />
      </div>
      <SkBar h="h-7" w="w-72" className="max-w-full mt-1" />
      <SkBar h="h-3" w="w-80" className="max-w-full" />
    </div>
    <div className="flex flex-wrap gap-2 flex-shrink-0">
      <SkBar h="h-9" w="w-36" className="rounded-md" />
      <SkBar h="h-9" w="w-28" className="rounded-md" />
      <SkBar h="h-9" w="w-32" className="rounded-md" />
    </div>
  </div>
);

const StatCard = () => (
  <Card className="shadow-sm" styles={{ body: { padding: 20 } }}>
    <div className="flex flex-col gap-2">
      <SkBar h="h-7" w="w-16" />
      <SkBar h="h-3" w="w-28" />
    </div>
  </Card>
);

const FilterRow = () => (
  <div className="flex flex-col sm:flex-row gap-3 mb-4">
    <SkBar h="h-10" w="w-full sm:flex-1 sm:max-w-md" className="rounded-md" />
    <SkBar h="h-10" w="w-full sm:w-48" className="rounded-md flex-shrink-0" />
  </div>
);

const EMPLOYEE_COLS = ['w-16', 'w-16', 'w-8', 'w-12', 'w-20', 'w-12', 'w-14'];

const EmployeeRow = () => (
  <div className="grid grid-cols-[2fr_2fr_1fr_0.8fr_1fr_1fr_0.8fr] gap-3 py-4 border-b border-gray-100 last:border-b-0 items-center">
    {/* Employee: avatar + name + code */}
    <div className="flex items-center gap-3 min-w-0">
      <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse flex-shrink-0" />
      <div className="flex-1 min-w-0 flex flex-col gap-1.5">
        <SkBar h="h-3" w="w-32" />
        <SkBar h="h-2" w="w-16" />
      </div>
    </div>
    {/* Contact: email + phone */}
    <div className="flex flex-col gap-1.5 min-w-0">
      <SkBar h="h-3" w="w-40" />
      <SkBar h="h-2" w="w-24" />
    </div>
    {/* Role pill */}
    <SkBar h="h-6" w="w-20" className="rounded-md" />
    {/* Branch */}
    <SkBar h="h-3" w="w-10" />
    {/* Points Award pill */}
    <SkBar h="h-6" w="w-20" className="rounded-md" />
    {/* Joined date */}
    <SkBar h="h-3" w="w-16" />
    {/* Actions */}
    <div className="flex items-center gap-2 justify-end">
      <SkBar h="h-8" w="w-8" className="rounded-md" />
      <SkBar h="h-8" w="w-6" className="rounded-md" />
    </div>
  </div>
);

const TablePagination = () => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-3 mt-4 pt-3">
    <SkBar h="h-3" w="w-36" />
    <div className="flex items-center gap-2">
      {Array.from({ length: 8 }).map((_, i) => (
        <SkBar key={i} h="h-8" w="w-8" className="rounded-md" />
      ))}
    </div>
    <SkBar h="h-8" w="w-24" className="rounded-md" />
  </div>
);

/**
 * EmployeesPageLoader — matches Employee Management layout:
 *  breadcrumb + header with 3 buttons (Download Template / Bulk Upload / Add Employee) ·
 *  4 stat cards (big colored number on top, label below) ·
 *  card with search + role filter · employee table · pagination.
 */
const EmployeesPageLoader = () => (
  <div className="w-full p-3 sm:p-4 md:p-6">
    <EmployeesHeader />

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
      {Array.from({ length: 4 }).map((_, i) => (
        <StatCard key={i} />
      ))}
    </div>

    <Card className="shadow-sm" styles={{ body: { padding: 20 } }}>
      <FilterRow />
      <div className="overflow-x-auto">
        <div className="min-w-[1000px]">
          <div className="grid grid-cols-[2fr_2fr_1fr_0.8fr_1fr_1fr_0.8fr] gap-3 pb-3 border-b border-gray-200">
            {EMPLOYEE_COLS.map((w, i) => (
              <SkBar
                key={i}
                h="h-3"
                w={w}
                className={i === EMPLOYEE_COLS.length - 1 ? 'justify-self-end' : ''}
              />
            ))}
          </div>
          {Array.from({ length: 9 }).map((_, i) => (
            <EmployeeRow key={i} />
          ))}
        </div>
      </div>
      <TablePagination />
    </Card>
  </div>
);

export default EmployeesPageLoader;
